import { Row, Col, Input, Select, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getProveedores } from "../../../../services/financiero/finProveedoresService";
import { getEstados } from "../../../../services/financiero/finEstadoService";
import ExportProductosButton from "./ExportProductosButton";
const { Option } = Select;

// Mapeo de estados a español
const estadoMap = {
  "FINALLY CLOSED": "Entregado",
  "CLOSED": "Cerrado",
  "CLOSED FOR RECEIVING": "Cerrado para recepción",
  "OPEN": "Pendiente",
  "PENDING": "Pendiente"
};

export default function ProductosFilters({ onFilter, filteredProductos, permissionExport }) {

  const [proveedores, setProveedores] = useState([]);
  const [estados, setEstados] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
    po: "",
    proveedor: null,
    estado: null,
  });

  useEffect(() => {
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    try {
      const prov = await getProveedores();
      const est = await getEstados();
      setProveedores(prov);
      setEstados(est);
    } catch (error) {
      console.error("Error cargando filtros");
    }
  };

  const handleChange = (key, value) => {
    const newFilters = {
      ...filters,
      [key]: value
    };

    setFilters(newFilters);

    if (onFilter) {
      onFilter(newFilters);
    }
  };

  const limpiarFiltros = () => {

    const empty = {
      search: "",
      po: "",
      proveedor: null,
      estado: null,
    };

    setFilters(empty);

    if (onFilter) {
      onFilter(empty);
    }
  };

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>

      {/* Buscar producto */}
      <Col xs={24} md={6}>
        <Input
          allowClear
          placeholder="Buscar producto"
          prefix={<SearchOutlined />}
          value={filters.search}
          onChange={(e) =>
            handleChange("search", e.target.value)
          }
        />
      </Col>

      {/* Número PO */}
      <Col xs={24} md={4}>
        <Input
          allowClear
          placeholder="Número PO"
          value={filters.po}
          onChange={(e) =>
            handleChange("po", e.target.value)
          }
        />
      </Col>

      {/* Proveedor */}
      <Col xs={24} md={5}>
        <Select
          allowClear
          placeholder="Proveedor"
          style={{ width: "100%" }}
          value={filters.proveedor}
          onChange={(value) =>
            handleChange("proveedor", value)
          }
        >
          {proveedores.map((p) => (
            <Option key={p.oid} value={p.oid}>
              {p.nombre}
            </Option>
          ))}
        </Select>
      </Col>

      {/* Estado */}
      <Col xs={24} md={4}>
        <Select
          allowClear
          placeholder="Estado"
          style={{ width: "100%" }}
          value={filters.estado}
          onChange={(value) =>
            handleChange("estado", value)
          }
        >
          {estados.map((e) => {

            const estadoVisual = estadoMap[e.estado] || e.estado;

            return (
              <Option key={e.oid} value={e.oid}>
                {estadoVisual}
              </Option>
            );
          })}
        </Select>
      </Col>

      {/* Limpiar filtros */}
      <Col xs={24} md={1}>
        <Space>
          <Button
            icon={<ClearOutlined />}
            onClick={limpiarFiltros}
          />
        </Space>
      </Col>
      {permissionExport && (
        <div style={{ marginBottom: 16 }}>
          <ExportProductosButton data={filteredProductos} />
        </div>
      )}

    </Row>
  );
}